const Sanitizer = {
    invoke : function(data){
        return;
        for(let propName in data){
            let propVal = data[propName];
            if(data[propName])
                data[propName] = Sanitizer.validate(propVal);
            else
                delete data[propName];
        }
    },
    validate : function(s){
        if(typeof s === "string")
            return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
        return s;
    }
}

module.exports = Sanitizer;


// WEBPACK FOOTER //
// ./src/control/util/Sanitizer.js